<template>
  <el-dialog title="新视窗数据对比" :close-on-click-modal="false" :visible.sync="dialogTableVisible" @close="onClose" width="80vw">
    <el-table v-loading="loading" :data="list" border ref="customerTable" style="width: 100%;" height="60vh">
      <el-table-column prop="客户编号" label="客户编号" width="100"></el-table-column>
      <el-table-column prop="客户名称" label="客户名称" width="120"></el-table-column>
      <el-table-column prop="客户昵称" label="客户昵称" width="120"></el-table-column>
      <el-table-column prop="客户性质" label="客户性质" width="70"></el-table-column>
      <el-table-column prop="客户状态" label="客户状态" width="70"></el-table-column>
      <el-table-column prop="客户类型" label="客户类型" width="70"></el-table-column>
      <el-table-column prop="家庭电话" label="家庭电话" width="120"></el-table-column>
      <el-table-column prop="工作电话" label="工作电话" width="120"></el-table-column>
      <el-table-column prop="性别" label="性别" width="70"></el-table-column>
      <el-table-column prop="所属组织" label="所属组织" width="200"></el-table-column>
      <el-table-column prop="主房产名称" label="主房产名称" width="320"></el-table-column>
      <el-table-column prop="手机" label="手机" width="120"></el-table-column>
      <el-table-column prop="摘要" label="摘要" width="100"></el-table-column>
      <el-table-column prop="登记时间" label="登记时间" width="100"></el-table-column>
      <el-table-column prop="身份证" label="身份证" width="150"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  name: "ShowXscCustomer",
  data(){
    return{
      dialogTableVisible:false,
      loading:false,
      list:[]
    }
  },
  methods:{
    show({house_id=0,house_name='',customer_id=0}){
      const that=this;
      that.dialogTableVisible=true;
      that.loading=true;
      that.getData({house_id,house_name,customer_id})
    },
    getData({
              house_id=0,
              house_name='',
              customer_id=0
            }){
      const that=this;
      ERP.getRequest({
        url:"admin/Customer/getXscCustomerHouse",
        data:{
          house_id:house_id,
          house_name:house_name,
          customer_id:customer_id
        }
      },ret=>{
        if(ret.code){
          that.list=ret.data;
        }else {
          that.$message.error(ret.msg||'数据异常');
        }
        that.loading=false;
      })
    },
    onClose(){
      this.dialogTableVisible=false;
      this.list=[];
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/ShowXscCustomer.vue